const curri = {
  mhesi: [
    {
      id: 1,
      level: "ปวช.",
      degreeName: "ปวช.",
      name: "ปวช.ช่างก่อสร้าง",
      shortName: "VB",
    },
    {
      id: 2,
      level: "ปวช.",
      degreeName: "ปวช.",
      name: "ปวช.ช่างไฟฟ้ากำลัง",
      shortName: "VP",
    },
    {
      id: 3,
      level: "ปวช.",
      degreeName: "ปวช.",
      name: "ปวช.ช่างยนต์",
      shortName: "VA",
    },
    {
      id: 4,
      level: "ปวช.",
      degreeName: "ปวช.",
      name: "ปวช.เทคโนโลยีการเขียนแบบเครื่องกล",
      shortName: "VD",
    },
    {
      id: 5,
      level: "ปวช.",
      degreeName: "ปวช.",
      name: "ปวช.ช่างอิเล็กทรอนิกส์",
      shortName: "VE",
    },
    {
      id: 6,
      level: "ปวช.",
      degreeName: "ปวช.",
      name: "ปวช.ช่างเทคนิคคอมพิวเตอร์",
      shortName: "VC",
    },
    {
      id: 7,
      level: "ปวส.",
      degreeName: "ปวส.",
      name: "ปวส.ช่างโยธา",
      shortName: "CT",
    },
    {
      id: 8,
      level: "ปวส.",
      degreeName: "ปวส.",
      name: "ปวส.ช่างก่อสร้าง",
      shortName: "BT",
    },
    {
      id: 9,
      level: "ปวส.",
      degreeName: "ปวส.",
      name: "ปวส.ช่างยนต์",
      shortName: "MP",
    },
    {
      id: 10,
      level: "ปวส.",
      degreeName: "ปวส.",
      name: "ปวส.ช่างกลเกษตร",
      shortName: "FM",
    },
    {
      id: 11,
      level: "ปวส.",
      degreeName: "ปวส.",
      name: "ปวส.ช่างกลโรงงาน",
      shortName: "MM",
    },
    {
      id: 12,
      level: "ปวส.",
      degreeName: "ปวส.",
      name: "ปวส.การออกแบบนวัตกรรมเครื่องจักรกล",
      shortName: "PD",
    },
    {
      id: 13,
      level: "ปวส.",
      degreeName: "ปวส.",
      name: "ปวส.อิเล็กทรอนิกส์",
      shortName: "EN",
    },
    {
      id: 14,
      level: "ปวส.",
      degreeName: "ปวส.",
      name: "ปวส.ช่างเครื่องมือกลอัตโนมัติ",
      shortName: "TM",
    },
    {
      id: 15,
      level: "ปวส.",
      degreeName: "ปวส.",
      name: "ปวส.ช่างท่อและประสาน",
      shortName: "IP",
    },
  ],
  tqf: [
    {
      id: 16,
      level: "ป.ตรี",
      degreeName: "ค.อ.บ.",
      name: "ค.อ.บ.ครุศาสตร์อุตสาหกรรมโยธา",
      shortName: "TCE",
    },
    {
      id: 17,
      level: "ป.ตรี",
      degreeName: "ค.อ.บ.",
      name: "ค.อ.บ.ครุศาสตร์อุตสาหกรรมไฟฟ้า ",
      shortName: "TEP",
    },
    {
      id: 18,
      level: "ป.ตรี",
      degreeName: "ค.อ.บ.",
      name: "ค.อ.บ.ครุศาสตร์อุตสาหกรรมเครื่องกล ",
      shortName: "TME",
    },
    {
      id: 19,
      level: "ป.ตรี",
      degreeName: "ค.อ.บ.",
      name: "ค.อ.บ.ครุศาสตร์อุตสาหกรรมอุตสาหการ ",
      shortName: "TIE",
    },
    {
      id: 20,
      level: "ป.ตรี",
      degreeName: "ค.อ.บ.",
      name: "ค.อ.บ.อิเล็กทรอนิกส์และโทรคมนาคม",
      shortName: "TEN",
    },
    {
      id: 21,
      level: "ป.ตรี",
      degreeName: "ค.อ.บ.",
      name: "ค.อ.บ.เทคโนโลยีคอมพิวเตอร์ ",
      shortName: "TEC",
    },
    {
      id: 22,
      level: "ป.ตรี",
      degreeName: "ค.อ.บ.",
      name: "ค.อ.บ.ครุศาสตร์อุตสาหกรรมการเชื่อม ",
      shortName: "TIW",
    },
    {
      id: 23,
      level: "ป.ตรี",
      degreeName: "อส.บ.",
      name: "อส.บ.เทคโนโลยีอุตสาหการ (ต่อเนื่อง)",
      shortName: "IDT",
    },
    {
      id: 24,
      level: "ป.ตรี",
      degreeName: "อส.บ.",
      name: "อส.บ.เทคโนโลยีท่ออุตสาหกรรม ",
      shortName: "IPT",
    },
    {
      id: 25,
      level: "ป.ตรี",
      degreeName: "อส.บ.",
      name: "อส.บ.เทคโนโลยีท่ออุตสาหกรรม (ต่อเนื่อง)",
      shortName: "IPT",
    },
    {
      id: 26,
      level: "ป.ตรี",
      degreeName: "อส.บ.",
      name: "อส.บ.เทคโนโลยีออกแบบการผลิต (ต่อเนื่อง)",
      shortName: "PDT",
    },
    {
      id: 27,
      level: "ป.ตรี",
      degreeName: "อส.บ.",
      name: "อส.บ.เทคโนโลยีการผลิตชิ้นส่วนยานยนต์ (ต่อเนื่อง)",
      shortName: "IAT",
    },
    {
      id: 28,
      level: "ป.ตรี",
      degreeName: "อส.บ.",
      name: "อส.บ.เทคโนโลยีเครื่องจักรกลการเกษตรอัตโนมัติ (ต่อเนื่อง)",
      shortName: "AAT",
    },
    {
      id: 29,
      level: "ป.ตรี",
      degreeName: "ศศ.บ.",
      name: "ศศ.บ.ภาษาอังกฤษเพื่อการจัดการทางธุรกิจ",
      shortName: "EBM",
    },
    {
      id: 30,
      level: "ป.โท",
      degreeName: "ค.อ.ม.",
      name: "ค.อ.ม.วิศวกรรมไฟฟ้าศึกษา",
      shortName: "MTEP",
    },
    {
      id: 31,
      level: "ป.โท",
      degreeName: "อส.ม.",
      name: "อส.ม.เทคโนโลยีระบบการผลิตอัตโนมัติ",
      shortName: "MAMT",
    },
  ],
};

export default curri;
